import { useContext, useState } from 'react'
import { NavLink } from "react-router-dom";
import {
  CircularProgressbar,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import styles from './BelowUltraWideMenu.module.scss';
import {
  MenuToList,
  MenuBottomList,
  UltraWideMenuToList,
} from "../../Menu.constants";
import classNames from 'classnames/bind';
import AppDataContext from '../../../../context/AppDataContext';
import Avatar from '../../../Avatar/Avatar';
import useWindowSize from '../../../../hooks/useWindowSize';
import EyRnButton from '../../../EyRnButton/EyRnButton';
let cx = classNames.bind(styles);

export default function BelowUltraWideMenu({ handleLogout }: any) {
  const { isUltraWide } = useWindowSize();
  const [isMenuExpand, setMenuExpand] = useState(false);
  const { user }: any = useContext(AppDataContext);
  const menuList = isUltraWide ? UltraWideMenuToList : MenuToList;

  let menuClassNames = cx({
    menu: true,
    expanded: isUltraWide,
  });


  return (
    <menu className={"menu-layout " + menuClassNames}>
      <div className={styles.menuItemTop}>
        {/* Brand Info and Menu Toggle */}
        <div
          className={styles.brand}
          onClick={() => setMenuExpand(!isMenuExpand)}
        >
          {!isUltraWide ? (
            <span className={styles.menuIcon}></span>
          ) : (
            <EyRnButton />
          )}

          <h4 className={styles.brandText}>EYRN</h4>
        </div>

        {/* Menu Top list */}
        <nav className={styles.menuNav}>
          {menuList.map((menuItem, i) => (
            <NavLink
              to={menuItem.path}
              key={i}
              aria-current="page"
              className={styles.menuNavItem}
            >
              {menuItem.icon === "eyrn" ? (
                <span className={styles.eyrnIcon}></span>
              ) : (
                <span className={"text-gray-300 icon-" + menuItem.icon}></span>
              )}

              <span className={styles.menuNavItemText}>{menuItem.name}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      <div className={styles.menuItemBottom}>
        <nav className={styles.menuNav}>
          {!isUltraWide &&
            MenuBottomList.map((menuItem, i) => (
              <NavLink
                to={menuItem.path}
                key={i}
                aria-current="page"
                className={styles.menuNavItem}
              >
                <span className={"text-gray-500  icon-" + menuItem.icon}></span>
                <span className={styles.menuNavItemText}>{menuItem.name}</span>
              </NavLink>
            ))}

          {isUltraWide && (
            <div className={styles.menuAlert}>
              <div className="mb-3" style={{ width: 70, height: 70 }}>
                <CircularProgressbar
                  value={76}
                  text={"760"}
                  strokeWidth={10}
                  styles={buildStyles({
                    textColor: "#FAFAFC",
                    pathColor: "#FAFAFC",
                    trailColor: "#3A3A4A"
                  })}
                />
              </div>
              <h4>Risk Health Score</h4>
              <p>
                Your Risk Health is very good. Continue to do great work!
              </p>
              <div className="d-flex">
                <button className="btn ph-0 text-gray-200 btn-flat mr-3">Dismiss</button>
                <button className="btn ph-0 text-white btn-flat">Learn More</button>
              </div>
            </div>
          )}
        </nav>

        <hr className={styles.hr} />

        {/* User Info */}
        <div className={styles.actionBox}>
          <div className={styles.userPane}>
            <Avatar src={user.picture} alt={user.fullName} status="Available" />

            <div className={styles.userPaneText}>
              <span className={styles.userPaneTextName}>{user.fullName}</span>
              <span className={styles.userPaneTextEmail}>{user.email}</span>
            </div>
          </div>

          <button onClick={() => handleLogout()} className={styles.btnLogout}>
            <span className="icon-log-out"></span>
          </button>
        </div>
      </div>
    </menu>
  );
}
